
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Bushireforpunetoashtavinayak() {



    const cardData =
    {
        keyword: 'Bus hire for Pune to Ashtavinayak',
        heading: 'Amruta Travels: Bus hire for Pune to Ashtavinayak',
        headingDescription: 'Amruta Travels offers Bus Hire for Pune to Ashtavinayak Darshan, providing a reliable and comfortable transportation solution for your spiritual journey to the eight revered Ganpati temples in Maharashtra. Whether you are planning a family pilgrimage, group tour, or corporate outing, our well-maintained buses ensure a smooth and devotional experience. Choose from our range of buses, including 17-seater, 32-seater, and 50-seater options, to suit your group size. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, Amruta Travels makes your Ashtavinayak Darshan from Pune simple and stress-free. Book your bus with Amruta Travels and embark on a journey of faith and comfort!',


        top: 'Top Places to Visit in Ashtavinayak with Amruta Travels',



   "topPlaces": [
  {
    "title": "Mayureshwar Temple, Morgaon",
    "description": "Located in Morgaon, Pune district, this temple is considered the starting and ending point of the Ashtavinayak Yatra. The deity here, Mayureshwar, is depicted riding a peacock, symbolizing the slaying of the demon Sindhu. The temple's architecture features a central shrine surrounded by a spacious courtyard and four minarets, resembling a mosque—a design choice made to protect it during invasions."
  },
  {
    "title": "Siddhivinayak Temple, Siddhatek",
    "description": "Situated on the banks of the Bhima River in Ahmednagar district, this temple is unique for its right-trunked Ganesha idol, which is considered especially powerful. The temple is accessible via a bridge and a series of steps, offering a serene environment for devotees seeking success and spiritual enlightenment."
  },
  {
    "title": "Ballaleshwar Temple, Pali",
    "description": "Located in Pali, Raigad district, this temple is named after the devoted child Ballal, who was blessed by Ganesha. It's the only temple where Ganesha is known by his devotee's name. The temple's design allows sunlight to fall directly on the deity during specific times of the year, enhancing its spiritual ambiance."
  },
  {
    "title": "Varadvinayak Temple, Mahad",
    "description": "Situated in Mahad, Raigad district, this temple is known for fulfilling devotees' wishes. The idol here is self-manifested (Swayambhu) and is placed in a sanctum that allows devotees to perform rituals directly. The temple is surrounded by a serene pond and lush greenery, providing a tranquil setting for worship."
  },
  {
    "title": "Chintamani Temple, Theur",
    "description": "Located in Theur, Pune district, this temple is associated with the legend of Ganesha retrieving the precious Chintamani jewel for sage Kapila. The temple's architecture includes a spacious hall and a sanctum housing the idol with a left-turned trunk, symbolizing peace and prosperity."
  },
  {
    "title": "Girijatmaj Temple, Lenyadri",
    "description": "Set within the Buddhist caves of Lenyadri near Junnar, this temple is unique as it's the only Ashtavinayak temple situated in a cave. The deity here is believed to be the child form of Ganesha, and the temple requires a climb of 307 steps, offering panoramic views of the surrounding landscape."
  },
  {
    "title": "Vighneshwar Temple, Ozar",
    "description": "Located in Ozar, Pune district, this temple is associated with the legend of Ganesha defeating the demon Vighnasur, who caused obstacles. The temple features a gold-plated dome and houses an idol with rubies for eyes and a diamond on the forehead, symbolizing the removal of obstacles."
  },
  {
    "title": "Mahaganapati Temple, Ranjangaon",
    "description": "Situated in Ranjangaon, Pune district, this temple is believed to be where Ganesha defeated the demon Tripurasura. The idol here is depicted with eight arms, symbolizing strength and power. The temple's architecture includes a spacious hall and a sanctum that houses the imposing idol."
  }
],


   "services": [
    {
      "name": "Ashtavinayak tour from Pune by bus Package",
      "description": "Amruta Travels offers an all-inclusive Ashtavinayak tour package from Pune by bus. Visit the eight sacred Ganesh temples of Maharashtra in a comfortable, well-maintained bus, ensuring a smooth and spiritual journey for groups of all sizes."
    },
    {
      "name": "Ashtavinayak Tour From Pune Bus Package",
      "description": "Our Ashtavinayak tour bus package from Pune provides a comfortable and hassle-free way to visit the revered Ashtavinayak temples. Enjoy expert guidance, timely services, and reliable transport for your divine journey."
    },
    {
      "name": "Ashtavinayak Darshan 32 Seater Bus Hire Pune",
      "description": "For medium-sized groups, Amruta Travels offers a 32-seater bus for Ashtavinayak Darshan from Pune. This spacious, air-conditioned bus ensures a comfortable journey to all eight temples, with ample space for a relaxed travel experience."
    },
    {
      "name": "Pune to Ranjangaon Ganpati Darshan Bus on Rent",
      "description": "Travel to Ranjangaon Ganpati with ease using our dedicated bus rental services. Whether it’s a group of friends, family, or colleagues, our buses offer comfort and punctuality, ensuring a smooth pilgrimage experience to this sacred temple."
    },
    {
      "name": "Bus hire for Pune to Ashtavinayak tour from Pune",
      "description": "Amruta Travels offers bus hire services for a seamless Ashtavinayak tour from Pune. Travel in comfort with our well-maintained buses and experienced drivers as you visit the eight significant Ganesh temples across Maharashtra."
    },
    {
      "name": "Best Ashtavinayak Tour From Pune Bus Service",
      "description": "For the best Ashtavinayak tour experience from Pune, Amruta Travels provides top-notch bus services. Our buses are equipped with modern amenities to ensure a comfortable, safe, and timely journey as you visit all the Ashtavinayak temples."
    },
    {
      "name": "32 35 40 Seater Bus Hire for Ashtavinayak",
      "description": "Amruta Travels offers 32, 35, and 40-seater buses for your Ashtavinayak tour. Whether you're planning a small group or a larger one, we have the perfect bus to ensure a comfortable and convenient pilgrimage journey to all the Ashtavinayak temples."
    },
    {
      "name": "Volvo Bus On for Ashtavinayak Darshan",
      "description": "For a luxurious Ashtavinayak Darshan experience, Amruta Travels offers Volvo buses. These high-end buses are equipped with plush interiors, providing you with a premium and comfortable experience on your spiritual journey."
    },
    {
      "name": "45 50 Seater Bus On Rent for Ashtavinayak Darshan",
      "description": "For larger groups, Amruta Travels offers 45 and 50-seater buses for Ashtavinayak Darshan. These buses provide ample space and comfort for your entire group, making your pilgrimage to the Ashtavinayak temples a relaxing experience."
    },
    {
      "name": "Pune to Morgaon Bus Hire on Rent",
      "description": "Amruta Travels offers bus rental services from Pune to Morgaon, home to one of the most important Ashtavinayak temples. Our buses ensure a comfortable and timely journey for a memorable pilgrimage experience."
    },
    {
      "name": "Pune to Siddhatek Ganpati Bus On Rent",
      "description": "Take a spiritual journey to Siddhatek Ganpati with Amruta Travels. We offer comfortable and convenient bus rental services from Pune to Siddhatek, ensuring a smooth and relaxing travel experience to this important Ganesh temple."
    },
    {
      "name": "Pune to Pali Ganpati Bus On Hire",
      "description": "Amruta Travels offers bus hire services from Pune to Pali Ganpati, a popular pilgrimage destination. Our buses are equipped with modern amenities, ensuring a comfortable and timely journey to this sacred site."
    },
    {
      "name": "Pune to Mahad Ganpati Bus On Hire",
      "description": "For a visit to Mahad Ganpati, Amruta Travels offers bus rental services that guarantee a smooth and enjoyable journey. Travel in comfort as you make your way to this important temple with our well-maintained buses."
    },
    {
      "name": "Pune to Theur Bus Hire",
      "description": "Amruta Travels offers convenient bus hire services for travel from Pune to Theur, home to another important Ashtavinayak temple. Our buses ensure a comfortable ride, allowing you to focus on the spiritual significance of your visit."
    },
    {
      "name": "Pune to Lenyadri Ganpati Bus On Rent",
      "description": "Travel to Lenyadri Ganpati from Pune with Amruta Travels' bus rental service. Our buses are equipped with all necessary amenities, ensuring a comfortable journey for your pilgrimage to this revered Ganesh temple."
    },
    {
      "name": "Pune to Ozar Ganpati Bus Hire",
      "description": "Amruta Travels provides bus hire services from Pune to Ozar Ganpati, another sacred stop on the Ashtavinayak tour. Our buses offer a comfortable, safe, and timely journey, so you can focus on the spiritual aspects of your trip."
    },
    {
      "name": "Pune to Ranjangaon Ganpati Bus Hire",
      "description": "For a visit to Ranjangaon Ganpati, Amruta Travels offers efficient bus rental services. Our buses provide comfort and convenience, ensuring a seamless pilgrimage journey from Pune to this important temple."
    }
  ],
  "tableData": [
    ["Ashtavinayak tour from Pune by bus Package", "Ashtavinayak Tour From Pune Bus Package"],
    ["Ashtavinayak Darshan 32 Seater Bus Hire Pune", "Pune to Ranjangaon Ganpati Darshan Bus on Rent"],
    ["Bus hire for Pune to Ashtavinayak tour from Pune", "Best Ashtavinayak Tour From Pune Bus Service"],
    ["32 35 40 Seater Bus Hire for Ashtavinayak", "Volvo Bus On for Ashtavinayak Darshan"],
    ["45 50 Seater Bus On Rent for Ashtavinayak Darshan", "Pune to Morgaon Bus Hire on Rent"],
    ["Pune to Siddhatek Ganpati Bus On Rent", "Pune to Pali Ganpati Bus On Hire"],
    ["Pune to Mahad Ganpati Bus On Hire", "Pune to Theur Bus Hire"],
    ["Pune to Lenyadri Ganpati Bus On Rent", "Pune to Ozar Ganpati Bus Hire"],
    ["Pune to Ranjangaon Ganpati Bus Hire", ""]
  ],





"whychoose": [
  {
    "WhyChooseheading": "Specialized Bus Hire for Pune to Ashtavinayak Darshan",
    "WhyChoosedescription": "Amruta Travels provides dedicated and well-organized bus hire services for the holy Ashtavinayak Yatra from Pune. Visiting all eight sacred Ganesh temples located across Maharashtra in a single circuit requires expert planning and comfortable travel. Our buses ensure a smooth, spiritually uplifting journey with complete flexibility and convenience for families, devotees, and pilgrimage groups."
  },
  {
    "WhyChooseheading": "Ideal for Pilgrimage Tours, Religious Groups, and Family Darshan",
    "WhyChoosedescription": "Whether you're organizing a one-day or two-day Ashtavinayak tour, our service is perfect for small to large groups. We cater to spiritual yatras with elders, family pilgrimages, and society or community groups seeking peaceful and well-managed travel to all eight Ashtavinayak temples—each with deep spiritual significance and unique legends."
  },
  {
    "WhyChooseheading": "Comfortable Buses for Long-Hour Devotional Travel",
    "WhyChoosedescription": "Traveling across all eight temples involves long distances and multiple stops. Our fleet includes AC and Non-AC buses in 17, 20, 32, 35, 40, 45, and 50-seater options, offering push-back seats, legroom, clean interiors, and sufficient luggage space. The comfortable seating helps devotees stay relaxed and refreshed during the full-day or overnight yatra."
  },
  {
    "WhyChooseheading": "Expert Drivers with Route Knowledge of All 8 Temples",
    "WhyChoosedescription": "Our drivers are experienced in the Ashtavinayak circuit, which includes Moreshwar (Morgaon), Siddhatek, Pali, Mahad, Theur, Lenyadri, Ozar, and Ranjangaon. They know the best routes, temple timings, traffic-prone areas, and ideal halts, ensuring your group follows a timely and well-managed schedule for darshan at each location."
  },
  {
    "WhyChooseheading": "Fully Customizable Itinerary Based on Your Schedule",
    "WhyChoosedescription": "We offer flexible Ashtavinayak tour plans, including 1-day express darshan or 2-day relaxed schedules with overnight halts. Whether you prefer early morning departure, temple-wise customization, or rest stops for meals and sightseeing, we tailor the trip to your convenience while covering all temples efficiently."
  },
  {
    "WhyChooseheading": "Affordable Pricing with Transparent Inclusions",
    "WhyChoosedescription": "Amruta Travels provides cost-effective packages for Pune to Ashtavinayak bus hire with no hidden charges. The pricing includes fuel, tolls, driver allowance, and taxes. We also offer special group rates for housing societies, corporate spiritual retreats, or religious trusts planning large-scale darshans."
  },
  {
    "WhyChooseheading": "Clean, Safe, and Devotion-Friendly Travel Experience",
    "WhyChoosedescription": "Our buses are thoroughly cleaned and sanitized before every trip. We maintain a calm and devotional environment, perfect for bhajans, prayers, or peaceful reflection during your pilgrimage. Safety, hygiene, and comfort are top priorities, especially when traveling with elders and families."
  },
  {
    "WhyChooseheading": "Easy Booking and End-to-End Yatra Support",
    "WhyChoosedescription": "Booking your Ashtavinayak bus is easy with Amruta Travels. Our team assists with route planning, temple timings, and even accommodation suggestions if needed. From initial inquiry to trip completion, we provide continuous support to ensure your journey remains organized and spiritually fulfilling."
  }
]





















    }

const faqData = [
  {
    question: 'Can I hire a bus from Pune for the Ashtavinayak Darshan?',
    answer: 'Yes, Amruta Travels offers convenient and comfortable bus hire services for Ashtavinayak Darshan from Pune. We help you cover all eight Ganpati temples with a well-planned itinerary.',
  },
  {
    question: 'What types of buses are available for the Ashtavinayak trip?',
    answer: 'We provide 32, 35, 40, 45, and 50-seater buses in both AC and non-AC variants. Luxury coaches with push-back seats and extra space are also available for a more relaxed journey.',
  },
  {
    question: 'Can the Ashtavinayak tour be completed in one day?',
    answer: 'Yes, the Ashtavinayak Darshan can be completed in one day with an early morning start. However, we also offer 2-day packages for a more relaxed and comfortable experience.',
  },
  {
    question: 'Is the itinerary customizable?',
    answer: 'Absolutely. You can customize the itinerary, pickup/drop locations, and add halts for meals or sightseeing. We’ll help you plan the most efficient and comfortable route.',
  },
  {
    question: 'Do your buses have enough space for luggage and prasad items?',
    answer: 'Yes, our buses have ample luggage storage, making it easy to carry prasad, bags, and other items during your spiritual journey.',
  },
  {
    question: 'Are your drivers experienced with the Ashtavinayak route?',
    answer: 'Yes, our drivers are well-versed with the entire Ashtavinayak circuit. They ensure a smooth and timely journey while covering all eight temples.',
  },
  {
    question: 'Is the service suitable for senior citizens or large families?',
    answer: 'Yes, we regularly organize Ashtavinayak trips for senior citizen groups and joint families. Our buses are clean, safe, and comfortable for travelers of all ages.',
  },
  {
    question: 'What is the cost of a bus hire for the Ashtavinayak trip?',
    answer: 'Pricing depends on the type of bus, duration (1-day or 2-day), and any additional services. Contact us with your group size and preferred travel date for a customized quote.',
  },
  {
    question: 'Why choose Amruta Travels for Ashtavinayak Darshan?',
    answer: 'Amruta Travels is trusted for religious tours with clean, well-maintained buses, trained drivers, and flexible packages. We ensure a peaceful and spiritual journey for all travelers.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Dinesh Kulkarni',
    role: 'Family Group Organizer',
    text: 'Our Ashtavinayak Darshan with Amruta Travels was smooth and well-managed. The bus was clean, the driver was polite, and the journey was comfortable. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Vandana Gokhale',
    role: 'Senior Citizen Group Leader',
    text: 'We hired a 40-seater bus for our senior citizen group’s Ashtavinayak Yatra. The trip was excellent. All temples were covered on time and everyone was comfortable throughout the journey.',
    rating: 5,
  },
];





































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ashtavinayak Bus on Rent Service",
  "image": "https://bushireinpune.com/assets/images/pune-to-ashtavinayak-bus-rent.jpg",
  "description": "Explore the Ashtavinayak temples with a convenient and comfortable bus hire from Pune. Choose from 32-seater, 35-seater, 40-seater, and Volvo buses for an unforgettable darshan experience. Amruta Travels offers affordable rates and excellent service for your spiritual journey.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3150"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3499",  // Adjust price based on service details
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-ashtavinayak-bus-on-rent"
  }
};





    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Pune to Ashtavinayak Bus Hire | Ashtavinayak Darshan, 32-50 Seater Buses | Amruta Travels</title>
  <meta 
    name="description" 
    content="Hire buses from Pune to Ashtavinayak for a divine darshan experience. Choose from 32, 35, 40, 45, and 50-seater buses for a comfortable and affordable journey." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/61.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bushireforpunetoashtavinayak;